module.exports = __webpack_public_path__ + "img/article-logo.ffca3f36.png";